import { BrowserHistory } from "history";
import React from "react";
import { Router } from "react-router";
import { RouterProps } from "react-router-dom";

interface Props extends Omit<RouterProps, 'location' | 'navigator'> {
    history: BrowserHistory
}

const CustomRouter: React.FC<Props> = ({
    basename,
    children,
    history,
}) => {
    const [state, setState] = React.useState({
        action: history.action,
        location: history.location,
    });

    React.useLayoutEffect(() => history.listen(setState), [history]);

    return (
        <Router
            basename={basename}
            children={children}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        />
    );
};

export default CustomRouter;